import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
    {
        id: "po-06-h6v0-01",
        name: "PO 01 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 45, y: 123, width: 565, height: 374, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 45, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 726, y: 165, width: 516, height: 322, rotation: 0, imageRotation: 0 },
            { id: "5", x: 726, y: 495, width: 254, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 495, width: 254, height: 159, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-02",
        name: "PO 02 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 45, y: 123, width: 565, height: 374, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 45, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 123, width: 565, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 701, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-03",
        name: "PO 03 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 45, y: 123, width: 565, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 505, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 323, width: 565, height: 374, rotation: 0, imageRotation: 0 },
            { id: "5", x: 701, y: 122, width: 279, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 122, width: 279, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-04",
        name: "PO 04 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 149, y: 71, width: 358, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 149, y: 300, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 149, y: 528, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 804, y: 71, width: 358, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 804, y: 300, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "6", x: 804, y: 528, width: 358, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-05",
        name: "PO 05 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 294, y: 71, width: 358, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 71, width: 358, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 294, y: 300, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 300, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 294, y: 528, width: 358, height: 220, rotation: 0, imageRotation: 0 },
            { id: "6", x: 660, y: 528, width: 358, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-06",
        name: "PO 06 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 112, y: 0, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 276, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 112, y: 552, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "4", x: 768, y: 0, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 276, width: 432, height: 268, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 552, width: 432, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-07",
        name: "PO 07 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
        size: [1311, 820],
        style: {},
        slots: [           
            { id: "1", x: 49, y: 195, width: 319, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 415, width: 319, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 376, y: 195, width: 665, height: 431, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1049, y: 195, width: 212, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1049, y: 342, width: 212, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1049, y: 488, width: 212, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-08",
        name: "PO 08 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 48, y: 150, width: 400, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 415, width: 400, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 456, y: 150, width: 400, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 456, y: 415, width: 400, height: 256, rotation: 0, imageRotation: 0 },
            { id: "5", x: 864, y: 150, width: 399, height: 257, rotation: 0, imageRotation: 0 },
            { id: "6", x: 864, y: 415, width: 399, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-09",
        name: "PO 09 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 165, width: 652, height: 489, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 165, width: 249, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 331, width: 249, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 497, width: 249, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 165, width: 394, height: 241, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 414, width: 394, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-10",
        name: "PO 10 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 260, width: 432, height: 300, rotation: 0, imageRotation: 0 },
            { id: "2", x: 880, y: 260, width: 431, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 440, y: 260, width: 212, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 440, y: 414, width: 212, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 660, y: 260, width: 212, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 660, y: 414, width: 212, height: 146, rotation: 0, imageRotation: 0 }
        ],
    }
];